

































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { RekapIntakeOutput } from "@/types/catatan_harian_bbl";

@Component
export default class BblRekapIntakeOutput extends Vue {
  @Prop({
    type: Object,
    default: () => ({
      shift1_intake: null,
      shift1_output: null,
      shift2_intake: null,
      shift2_output: null,
      shift3_intake: null,
      shift3_output: null,
      total_intake: 0,
      total_output: 0,
      balance: 0,
    }),
  })
  readonly rekap!: RekapIntakeOutput;

  @Prop({ type: Boolean, default: false }) readonly locked!: boolean;

  local: RekapIntakeOutput = {
    shift1_intake: null,
    shift1_output: null,
    shift2_intake: null,
    shift2_output: null,
    shift3_intake: null,
    shift3_output: null,
    total_intake: 0,
    total_output: 0,
    balance: 0,
  };

  @Watch("rekap", { immediate: true, deep: true })
  onRekapChange(val: RekapIntakeOutput): void {
    this.local = { ...val };
  }

  get totalIntake(): number {
    return (
      (this.local.shift1_intake || 0) +
      (this.local.shift2_intake || 0) +
      (this.local.shift3_intake || 0)
    );
  }

  get totalOutput(): number {
    return (
      (this.local.shift1_output || 0) +
      (this.local.shift2_output || 0) +
      (this.local.shift3_output || 0)
    );
  }

  get balance(): number {
    return this.totalIntake - this.totalOutput;
  }

  get balanceColor(): string {
    return this.balance >= 0 ? "green--text" : "red--text";
  }

  onInput(field: keyof RekapIntakeOutput, value: string): void {
    const num = value === "" ? null : parseFloat(value);
    (this.local as any)[field] = num;
    this.emitUpdate();
  }

  emitUpdate(): void {
    this.$emit("update", {
      ...this.local,
      total_intake: this.totalIntake,
      total_output: this.totalOutput,
      balance: this.balance,
    });
  }
}
